import { useEffect } from 'react';

export const usePageTitle = (...titles: Array<string>) => {
  const title = titles.join(' - ');

  useEffect(() => {
    document.title = title;
  }, [title]);
};
